<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.status"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click="handleEdit(item)"
                authorize="edit-regulacao-status"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="handleDestroy(item)"
                authorize="destroy-regulacao-status"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { error, repository } from '@/mixins'

export default {
    created() {

        this.repositories = {
            status: this.getConectaSusRepository('regulacao.status'),
        }
    },
    data: () => ({
        fields: [
            {
                key: 'nome',
                label: 'Nome',
                name: 'status.nome',
                searchable: true,
                sortable: true,
            },
            {
                key: 'tipoNome',
                label: 'Tipo',
                name: 'statusTipo.nome',
                searchable: true,
                sortable: true,
            },
            {
                key: 'statusPara',
                label: 'Status para encaminhamento',
            },
            {
                class: 'col-min',
                key: 'actions',
                label: 'Ações',
            },
        ],
    }),
    methods: {
        handleEdit({ id }) {

            this.$router.push({ name: 'regulacao-status-edit', params: { id } })
        },
        handleDestroy({ id }) {

            const destroy = () => this.repositories.status.destroy(id)
                .then(() => this.$refs.DataTable.refresh())
        
            this.showDeleteConfirmation('Deseja realmente excluir o status?', destroy, this.handleError)

        },
    },
    mixins: [error, repository],
}
</script>